import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { GenderButton } from 'page/ProfileScreen/Genders/GenderButton'
import { opt } from 'store/opt'

export const Genders = observer(() => {
  const male = !opt.irnby

  return <Panel>
    <GenderButton gender="female" />
    {male && <GenderButton gender="male" />}
  </Panel>
})
